import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

import { filter, distinctUntilChanged } from 'rxjs/operators';

import { FilterToggleEvent, FilterItem } from '../../models/filter';

@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss']
})
export class FilterItemComponent implements OnInit {
  applied: boolean = false
  checkBoxControl = new FormControl()

  @Input() filterItem: FilterItem
  @Input('isApplied') set isApplied(value: boolean) {
    this.applied = value
    this.checkBoxControl.setValue(value)
  }

  @Output() filterToggled = new EventEmitter<FilterToggleEvent>()

  ngOnInit() {
    this.checkBoxControl.valueChanges
      .subscribe(this.toggled.bind(this))
  }

  private toggled() {
    this.filterToggled.emit({
      code: this.filterItem.code
    })
  }

}
